module.exports = __webpack_public_path__ + "static/media/weddingPlannerFront2.57fbbca8.png";